import { cn } from "@/util/string";

interface Step {
	label: string;
}

interface StepIndicatorProps {
	steps: Step[];
	currentStep: number;
}

/** Horizontal step indicator using DaisyUI steps component. */
export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
	return (
		<ul className="steps steps-horizontal mb-10 w-full">
			{steps.map((step, index) => (
				<li
					key={step.label}
					className={cn("step", index <= currentStep && "step-primary")}
				>
					{step.label}
				</li>
			))}
		</ul>
	);
}
